import * as React from 'react';
import { injectIntl, FormattedMessage, InjectedIntlProps } from 'react-intl';

import { createStyles, withStyles, WithStyles } from "@material-ui/core";
import Button from '@material-ui/core/Button';
import Step from '@material-ui/core/Step';
import Stepper from '@material-ui/core/Stepper';
import StepContent from '@material-ui/core/StepContent';
import StepLabel from '@material-ui/core/StepLabel';
import Tooltip from "@material-ui/core/Tooltip";
import Typography from '@material-ui/core/Typography';

import { ProcessStep } from '../constants';
import { getProcessStepTranslations } from "../services/translation-store";


interface Props {
    readonly processStep: ProcessStep,
    readonly onProcessStepChanged: (processStep: ProcessStep) => void,
}

interface StepperButtonProps {
    readonly onBackButtonClicked?: () => void,
    readonly backButtonTooltip?: string,
    readonly onNextButtonClicked?: () => void,
    readonly nextButtonTooltip?: string,
}

const styles = createStyles({
    hidden: {
        visibility: 'hidden'
    },
    moreInfo: {
        textDecoration: 'underline',
        cursor: 'pointer',
        textAlign: 'right',
        marginTop: 5,
        marginBottom: 20,
    },
});

type Styles = 'hidden' | 'moreInfo';

const StepperButtons = ({ intl, classes, backButtonTooltip, onBackButtonClicked, nextButtonTooltip, onNextButtonClicked }: StepperButtonProps & WithStyles<Styles> & InjectedIntlProps) => (
    <div className="hbox">
        {onBackButtonClicked?
            <Tooltip title={intl.formatMessage({id: backButtonTooltip || ''})}>
                <Button onClick={onBackButtonClicked}>
                    <FormattedMessage id="back"/>
                </Button>
            </Tooltip>
            :
            <Button disabled={true} className={classes.hidden}>
                <FormattedMessage id="back"/>
            </Button>
        }
        {onNextButtonClicked?
            <Tooltip title={intl.formatMessage({ id: nextButtonTooltip || '' } )}>
                <Button
                    variant="contained"
                    color="primary"
                    onClick={onNextButtonClicked}
                >
                    <FormattedMessage id="next"/>
                </Button>
            </Tooltip>
            :
            <Button disabled={true} className={classes.hidden}>
                <FormattedMessage id="next"/>
            </Button>

        }
    </div>
);

const ProgressStepper = ({ classes, intl, processStep, onProcessStepChanged }: Props & WithStyles<Styles> & InjectedIntlProps) => {
    const brainstormTranslationKeys = getProcessStepTranslations(ProcessStep.BRAINSTORM);
    const basicDataTranslationKeys = getProcessStepTranslations(ProcessStep.BASIC_DATA);
    const structureTranslationKeys = getProcessStepTranslations(ProcessStep.STRUCTURE);
    const sketchTranslationKeys = getProcessStepTranslations(ProcessStep.SKETCH);
    const exportTranslationKeys = getProcessStepTranslations(ProcessStep.EXPORT);
    let processStepIndex = 0;
    switch (processStep) {
        case ProcessStep.BASIC_DATA:
            processStepIndex = 1;
            break;
        case ProcessStep.STRUCTURE:
            processStepIndex = 2;
            break;
        case ProcessStep.SKETCH:
            processStepIndex = 3;
            break;
        case ProcessStep.EXPORT:
            processStepIndex = 4;
            break;
    }
    return (
        <Stepper activeStep={processStepIndex} orientation="vertical">
            <Step>
                <StepLabel><FormattedMessage id={brainstormTranslationKeys.label}/></StepLabel>
                <StepContent>
                    <Typography>
                        <FormattedMessage id={brainstormTranslationKeys.summary}/>
                    </Typography>
                    <StepperButtons intl={intl}
                                    classes={classes}
                                    nextButtonTooltip={brainstormTranslationKeys.next_tooltip}
                                    onNextButtonClicked={() => onProcessStepChanged(ProcessStep.BASIC_DATA)}
                    />
                </StepContent>
            </Step>
            <Step>
                <StepLabel><FormattedMessage id={basicDataTranslationKeys.label}/></StepLabel>
                <StepContent>
                    <Typography>
                        <FormattedMessage id={basicDataTranslationKeys.summary}/>
                    </Typography>
                    <StepperButtons intl={intl}
                                    classes={classes}
                                    backButtonTooltip={basicDataTranslationKeys.back_tooltip}
                                    nextButtonTooltip={basicDataTranslationKeys.next_tooltip}
                                    onBackButtonClicked={() => onProcessStepChanged(ProcessStep.BRAINSTORM)}
                                    onNextButtonClicked={() => onProcessStepChanged(ProcessStep.STRUCTURE)}
                    />
                </StepContent>
            </Step>
            <Step>
                <StepLabel><FormattedMessage id={structureTranslationKeys.label}/></StepLabel>
                <StepContent>
                    <Typography>
                        <FormattedMessage id={structureTranslationKeys.summary}/>
                    </Typography>
                    <StepperButtons intl={intl}
                                    classes={classes}
                                    backButtonTooltip={structureTranslationKeys.back_tooltip}
                                    nextButtonTooltip={structureTranslationKeys.next_tooltip}
                                    onBackButtonClicked={() => onProcessStepChanged(ProcessStep.BASIC_DATA)}
                                    onNextButtonClicked={() => onProcessStepChanged(ProcessStep.SKETCH)}
                    />
                </StepContent>
            </Step>
            <Step>
                <StepLabel><FormattedMessage id={sketchTranslationKeys.label}/></StepLabel>
                <StepContent>
                    <Typography>
                        <FormattedMessage id={sketchTranslationKeys.summary}/>
                    </Typography>
                    <StepperButtons intl={intl}
                                    classes={classes}
                                    backButtonTooltip={sketchTranslationKeys.back_tooltip}
                                    nextButtonTooltip={sketchTranslationKeys.next_tooltip}
                                    onBackButtonClicked={() => onProcessStepChanged(ProcessStep.STRUCTURE)}
                                    onNextButtonClicked={() => onProcessStepChanged(ProcessStep.EXPORT)}
                    />
                </StepContent>
            </Step>
            <Step>
                <StepLabel><FormattedMessage id={exportTranslationKeys.label}/></StepLabel>
                <StepContent>
                    <Typography>
                        <FormattedMessage id={exportTranslationKeys.summary}/>
                    </Typography>
                    <StepperButtons intl={intl}
                                    classes={classes}
                                    backButtonTooltip={exportTranslationKeys.back_tooltip}
                                    onBackButtonClicked={() => onProcessStepChanged(ProcessStep.SKETCH)}
                    />
                </StepContent>
            </Step>
        </Stepper>
    );
};

export default withStyles(styles)(injectIntl(ProgressStepper));



// WEBPACK FOOTER //
// ./src/components/ProgressStepperView.tsx